var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMapPinYellow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-svgrepo-com (1) 1",
    clipPath: "url(#clip0_196_15573)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.0001 0.894043C6.76847 0.894043 4.1394 3.52311 4.1394 6.7547C4.1394 7.63601 4.3303 8.483 4.70664 9.27271C4.71421 9.28961 4.72217 9.3062 4.73065 9.32279L9.15869 17.8964C9.32125 18.211 9.64585 18.4088 9.99999 18.4088C10.3542 18.4088 10.6788 18.2111 10.8413 17.8964L15.2681 9.32513C15.2758 9.31036 15.2829 9.29544 15.2897 9.28036C15.6686 8.48837 15.8606 7.63881 15.8606 6.7547C15.8607 3.52311 13.2317 0.894043 10.0001 0.894043ZM10.0001 9.8223C8.30859 9.8223 6.93247 8.44618 6.93247 6.7547C6.93247 5.0633 8.30859 3.68719 10.0001 3.68719C11.6915 3.68719 13.0677 5.0633 13.0677 6.7547C13.0677 8.44618 11.6915 9.8223 10.0001 9.8223Z",
    fill: "#FBAA19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.2575 19.7578H7.74246C7.42862 19.7578 7.17432 20.0121 7.17432 20.3259C7.17432 20.6397 7.42862 20.894 7.74246 20.894H12.2575C12.5713 20.894 12.8256 20.6397 12.8256 20.3259C12.8256 20.0121 12.5712 19.7578 12.2575 19.7578Z",
    fill: "#FBAA19"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_196_15573"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.894043)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPinYellow);
export default __webpack_public_path__ + "static/media/map-pin-yellow.ab854ddbb8142d7217531209e170486a.svg";
export { ForwardRef as ReactComponent };